import reducer from './reducers';

export { default as followersOperations } from './operations';
export { default as followersTypes } from './types';

export default reducer;
